import { Directive, Input, TemplateRef, inject } from '@angular/core';
import { StepperStepConfig } from './stepper.types';

/**
 * StepperStep Directive
 * 
 * Used to define individual steps in the stepper.
 * Similar to Angular Material's mat-step pattern.
 * 
 * @example
 * ```html
 * <app-stepper [config]="config">
 *   <div *stepperStep="step0Config">
 *     <!-- Step 0 content -->
 *   </div>
 *   <div *stepperStep="step1Config">
 *     <!-- Step 1 content -->
 *   </div>
 * </app-stepper>
 * ```
 */
@Directive({
  selector: '[stepperStep]',
  standalone: true,
})
export class StepperStepDirective {
  /** Template reference for the step content */
  templateRef = inject(TemplateRef<any>);
  
  /** Step configuration */
  @Input({ required: true }) stepperStep!: StepperStepConfig;
  
  /** Optional: Step index (auto-assigned by stepper) */
  @Input() stepIndex?: number;
}

